// extracted by mini-css-extract-plugin
module.exports =  {"mergetagselect":"NfKPcfZkYOqpQUImlJY_"};